'use strict';

function init() {
	var template = document.getElementsByClassName('_news');
	if (!template.length)
		return;

	var btn = document.getElementsByClassName('btn--back')[0];
	if (document.referrer.indexOf('news') !== -1) {
		// If user coming from NewsListing, use window history back
		btn.addEventListener('click', function handleBackTo(event) {
			event.preventDefault();
			window.history.back();
		});
	}
}

module.exports = {
	init: init
}
